import { render, staticRenderFns } from "./ENotificacoesList.vue?vue&type=template&id=5cb8a387"
import script from "./ENotificacoesList.vue?vue&type=script&lang=js"
export * from "./ENotificacoesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports